import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import LazyImage from '../Atoms/LazyImage.js';

function HeroOne(_a) {
    var classes = _a.classes, title = _a.title, backgroundImage = _a.backgroundImage, logo = _a.logo, locationSearch = _a.locationSearch, imageComponent = _a.imageComponent;
    return (React__default.createElement("div", { style: {
            backgroundImage: "url(".concat(backgroundImage, ")")
        }, className: classNames('hero-one', classes) },
        React__default.createElement("div", { className: "hero-one__content" },
            React__default.createElement(LazyImage, { src: logo, alt: "hero-logo", classes: "hero-one__logo", imageComponent: imageComponent }),
            title ? (React__default.createElement(Typography, { weight: "semibold", classes: "hero-one__title", variant: 'headingTwo' }, title)) : null,
            locationSearch ? (React__default.createElement("div", { className: "hero-one__location-search" }, locationSearch)) : null)));
}

export { HeroOne as default };
//# sourceMappingURL=HeroOne.js.map
